import { createStore } from 'vuex';
import modules from "./modules";

export default createStore({

    modules: modules
        // state: {
        //     arrAskpr: [1, 2, 5],
        // }
})